import React, { Component } from 'react';
import '../componentform.css';
import componentFormService from '../ComponentFormService.js';
import componentMap from '../../../ComponentMap';
import { showConfirmation } from '../../../ConfirmationModal';
import { showNotification } from '../../../StatusNotification';

export class CalendarForm extends Component {
    static displayName = CalendarForm.name;

    constructor(props) {
        super(props);
        this.state = {
            calendar: null,
            formType: null,
            pageId: this.props.pageId,
            versionId: this.props.versionId,
            versionStatus: this.props.versionStatus,
            isEditOnly: this.props.isEditOnly != undefined ? this.props.isEditOnly : false,
            isInPopup: this.props.isInPopup != undefined ? this.props.isInPopup : false
        };
    }

    componentDidMount() {
        this.getComponentData();
    }

    handleSubmit = (e) => {
        e.preventDefault();

        let calendar = this.state.calendar;
        calendar.versionId = this.state.versionId;
        calendar.pageId = this.state.pageId;
        let url = this.state.formType == "Update" ? "UpdateCalendar" : "CreateCalendar";
        fetch('Admin/' + url, {
            method: 'POST',
            body: JSON.stringify(calendar),
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        }).then(
            response => response.json()
        ).then(
            data => {
                if (!isNaN(data)) {
                    if (!this.state.isEditOnly) {
                        var pageComponentId = this.props.pageComponentId != undefined ? this.props.pageComponentId : 0;
                        var isDataSaved = componentFormService.managePageComponent(this.state.pageId, "Calendar", parseInt(data), parseInt(pageComponentId), this.state.versionId, this.state.versionStatus);
                    }

                    this.props.onComponentSaved();
                }
                else {
                    showNotification(data, "error");
                }
            }
        );
    }

    handleChange = (e) => {
        let newCalendar = this.state.calendar;
        newCalendar[e.target.name] = e.target.value;
        this.setState({ calendar: newCalendar });
    }

    render() {
        let deleteButton = this.state.formType == "Update" ? <button className='delete-btn' onClick={this.deleteComponent.bind(this)}>Delete</button> : null;
        if (this.state.isInPopup) {
            deleteButton = null;
        }

        let componentName;
        let format;

        if (this.state.calendar != null) {
            let calendar = this.state.calendar;
            componentName = calendar.componentName;
            format = calendar.format;
        }

        let wrapperClasses = this.state.versionStatus == 'draft' ? 'grid-wrapper component-form' : 'grid-wrapper component-form disable-form';
        return (
            <form onSubmit={this.handleSubmit} className={wrapperClasses}>
                <div className='dual-grid'>
                    <div className='dual-grid__1-2 form-title'>
                        <h2>{componentName} {componentMap.componentTypeDisplay('Calendar')}</h2>
                    </div>

                    <label htmlFor='calendar-componentName'>Component Name: </label>
                    <input id='calendar-componentName' name='componentName' type='text' defaultValue={componentName} onChange={this.handleChange} required maxLength='15' />

                    <label htmlFor='calendar-format'>Format: </label>
                    <select id='calendar-format' name='format' value={format} onChange={this.handleChange} required>
                        <option key='formatOpt0' value=''>--Select--</option>
                        <option key='formatOpt1' value='M/D/YY'>M/D/YY</option>
                        <option key='formatOpt2' value='Month D, YY'>Month DD, YY</option>
                    </select>

                    <div className='dual-grid__1-2'>
                        <button type='submit'>Save</button>
                        {deleteButton}
                    </div>
                </div>
            </form>
        );
    }

    async getComponentData() {
        let componentId = (this.props.componentId !== undefined) ? this.props.componentId : 0;
        let formType = this.props.formType !== undefined ? this.props.formType : 'Create';

        const response = await fetch('Admin/GetCalendar?componentId=' + componentId, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        });

        const data = await response.json();

        this.setState({
            calendar: data,
            formType: formType
        });
    }

    async deleteComponent(e) {
        e.preventDefault();
        let confirmDelete = await showConfirmation("Are you sure you want to delete this component and remove all associations to it?");

        if (confirmDelete) {
            const response = await fetch('Admin/DeleteCalendar?componentId=' + this.state.calendar.id, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                }
            });

            const data = await response.json();

            if (data === "Deleted") {
                this.props.onComponentDeleted();
            }
            else {
                showNotification(data, "error");
            }
        }
    }
}

export default CalendarForm;
